import { Outlet, createFileRoute } from "@tanstack/react-router";

/**
 * Layout for the policies tree. The library lives in the index route and the
 * document page in `$policyId`, so this only needs to give them somewhere to
 * render — without an `Outlet` the child route matches the URL and shows
 * nothing.
 */
export const Route = createFileRoute("/$org/compliance/policies")({
  component: Outlet,
});
